import React, { useMemo, useReducer } from "react";
import Render from "../../utilities/Render";
import ListingFilter, {
  generateTermsList,
  initState,
  listingReducer
} from "../listing-filter/ListingFilter";
import HubArticlesCard from "./HubArticlesCard";

const HubArticlesListing = ({ data: allItems }) => {
  const [state, dispatch] = useReducer(listingReducer, { allItems }, initState);

  const topics = useMemo(
    () => generateTermsList("primaryTopic", state.allItems),
    []
  );

  return (
    <div className="container" id="hub-articles">
      <ListingFilter callback={dispatch} state={state}>
        <div className="row">
          <div className="col-sm-12 col-md-3 filtering-panel">
            <ListingFilter.SearchFilter
              title="Search"
              placeholder="Search articles"
              searchFields={["title", "summary"]}
            />

            <ListingFilter.FiltersCollapse>
              <ListingFilter.CheckboxTerms
                title="Topic"
                category="primaryTopic"
                terms={topics}
              />
            </ListingFilter.FiltersCollapse>
            <ListingFilter.ClearButton />
          </div>

          <div className="col-sm-12 col-md-9 card-grid">
            <div className="row">
              <ListingFilter.NoResults>
                <div className="col">
                  <p>No results found.</p>
                </div>
              </ListingFilter.NoResults>

              {state.paginatedItems.map((item, index) => (
                <div key={index} className="col-sm-6 col-md-6 col-lg-4 mb-4">
                  <HubArticlesCard article={item} />
                </div>
              ))}
            </div>

            <ListingFilter.Pagination />
          </div>
        </div>
      </ListingFilter>
    </div>
  );
};

Render.Component(
  "#hub-articles-listing-react",
  hubArticlesData,
  HubArticlesListing
);

export default HubArticlesListing;
